import { AuthState } from '@/store/modules/auth/types';

const tokenFromLocalStorage = window.localStorage.getItem('store')
  ? JSON.parse(window.localStorage.getItem('store')!).auth.token
  : '';

const state: AuthState = {
  token: tokenFromLocalStorage,
};

export default state;
